"use client";

import React from "react";

import { PlottingColorByEnum } from "@/app/(internal)/panel/(maps)/_enums/plotting-filters.enum";
import { Card } from "@/components/flowbite/card";
import { STUDENT_BY_TITLE_DICTIONARY } from "@/components/maps/map-panel/map-panel-details-panel/components/student-by.constants";
import { usePlottingFilters } from "@/providers/maps/contexts/plotting-filters-context";
import { toStudentCountsColorBy } from "@/providers/maps/utils/to-student-counts-color-by";

import { SectionTitle } from "./section-title";
import { SkeletonBox } from "./skeleton-box";

export const StudentClusterPanelSkeleton: React.FC = () => {
  const { colorBy: plottingColorBy } = usePlottingFilters();
  const colorBy = toStudentCountsColorBy(plottingColorBy);
  const showStudentBySkeleton = plottingColorBy !== PlottingColorByEnum.NONE;

  return (
    <div className="space-y-6 px-3 py-4">
      <div>
        <SectionTitle title="Summary" />
        <div className="mt-2">
          <Card className="flex flex-col gap-2 border-none bg-gray-100 p-2">
            <div className="flex gap-2">
              <SkeletonBox className="h-8 w-12" />
              <SkeletonBox className="h-6 w-6 shrink-0 rounded" />
            </div>
            <SkeletonBox className="h-4 w-16" />
          </Card>
        </div>
      </div>

      {showStudentBySkeleton ? (
        <div>
          <SectionTitle title={STUDENT_BY_TITLE_DICTIONARY[colorBy]} />
          <div className="mt-2 space-y-1">
            <div className="flex gap-2">
              <SkeletonBox className="h-4 w-16 shrink-0" />
              <SkeletonBox className="h-4 flex-1" />
              <SkeletonBox className="h-4 w-12 shrink-0" />
            </div>
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="flex gap-2"
              >
                <SkeletonBox className="h-4 w-20 shrink-0" />
                <SkeletonBox className="h-4 flex-1" />
                <SkeletonBox className="h-4 w-10 shrink-0" />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};
